<!-- /**
* 工队详情页面
* @authors zzt
* @date 2019/1/28
* @version 1.0
*/ -->
<template>
  <div class="talents">
    <div class="talents_details">
      <Breadcrumb :breadcrumbName="breadcrumbObj"></Breadcrumb>
      <div class="talents_details_content">
        <div class="talents_details_content_left">
          <div class="titleTop">
            <div class="left">设备详情</div>
            <div class="right" @click="goBack">返回团队详情</div>
          </div>
          <div class="equInfoDeatils">
            <div class="equInfoDeatils_Content">
              <!-- <div class="title">设备详情</div> -->
              <div class="titleText">{{ equipmentDetails.name }}</div>
              <div class="titleType">
                设备型号：{{ equipmentDetails.model }}
              </div>
              <div class="titleBorder">
                <div>设备描述</div>
              </div>
              <div class="des">
                <div
                  ref="textShow"
                  class="text"
                  :class="[!ShowMoreText ? 'actionShow' : '']"
                >
                  <!-- <span>
                    {{equipmentDetails.describe}}
                  </span> -->
                  <span
                    style="white-space: pre-wrap;"
                    v-if="equipmentDetails.describe"
                    v-html="equipmentDetails.describe"
                  >
                  </span>
                </div>
                <div class="optionShow" v-show="isHtml">
                  <span
                    v-if="ShowMoreText"
                    class="showUp"
                    @click="ShowMoreText = false"
                  >
                    查看更多<i class="el-icon-caret-bottom"></i>
                  </span>
                  <span v-else class="showDown" @click="ShowMoreText = true">
                    点击收起<i class="el-icon-caret-top"></i>
                  </span>
                </div>
              </div>
              <div class="titleBorder">
                <div>设备照片</div>
              </div>
              <div class="imgBox">
                <div>
                  <!-- <img
            v-for="(item,index) in equipmentDetails.picture"
            :src="item"
            :key="index"
            alt=""
          > -->
                  <el-image
                    v-for="(item, index) in equipmentDetails.picture"
                    style="width: 216px; height: 140px"
                    :src="item"
                    :key="index"
                    :preview-src-list="equipmentDetails.picture"
                  >
                  </el-image>
                </div>
              </div>
              <div class="titleBorder">
                <div>证明材料</div>
              </div>
              <div class="imgBox">
                <div>
                  <!-- <img
            v-for="(item,index) in equipmentDetails.picturePic"
            :src="item"
            :key="index"
            alt=""
          > -->
                  <el-image
                    v-for="(item, index) in equipmentDetails.picturePic"
                    style="width: 216px; height: 140px"
                    :src="item"
                    :key="index"
                    :preview-src-list="equipmentDetails.picturePic"
                  >
                  </el-image>
                </div>
              </div>
              <div class="imgBox">
                <div>
                  <video
                    v-for="(item, index) in equipmentDetails.pictureVideo"
                    style="width:420px;height:270px"
                    :src="item"
                    :key="index + 1"
                    class="avatar"
                    controls="controls"
                  >
                    您的浏览器不支持视频播放
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="talents_details_content_right">
          <div v-if="messageData.isCompany == 0" class="PersonMessage">
            <div class="name">
              <el-tooltip
                popper-class="changeTootip"
                effect="light"
                :visible-arrow="false"
                :content="messageData.teamName"
                placement="bottom"
                :offset="10"
              >
                <div class="describe">{{ messageData.teamName }}</div>
              </el-tooltip>
              <!-- <span class="text">{{messageData.teamName}}</span> -->
              <span class="icon">个体</span>
            </div>
            <div class="imgIcon">
              <img src="@/assets/redesignImg/person.png" alt="" />
              <img src="@/assets/redesignImg/phone.png" alt="" />
            </div>
            <div class="item">联系人：{{ messageData.contact }}</div>
            <div class="item">
              联系电话：
              <span v-if="showpNumber">
                {{ messageData.phoneNumber }}
              </span>
              <span v-else>
                {{ ShowPhone(messageData.phoneNumber) }}
              </span>
              <span
                class="showText"
                v-if="!showpNumber"
                @click="ShowPhoneNumber"
              >查看完整号码</span
              >
            </div>
            <div class="box" @click="OnlineConsulting">
              <img src="@/assets/redesignImg/msg.png" alt="" />
              在线咨询
            </div>
          </div>
          <div v-else-if="messageData.isCompany == 1" class="EnterpriseMessage">
            <div class="name">
              <el-tooltip
                popper-class="changeTootip"
                effect="light"
                :visible-arrow="false"
                :content="messageData.teamName"
                placement="bottom"
                :offset="10"
              >
                <div class="describe">{{ messageData.teamName }}</div>
              </el-tooltip>
              <!-- <span class="text">{{messageData.teamName}}</span> -->
              <span class="icon">企业</span>
            </div>
            <div class="imgIcon">
              <img src="@/assets/redesignImg/person.png" alt="" />
              <img src="@/assets/redesignImg/phone.png" alt="" />
              <img src="@/assets/redesignImg/ern.png" alt="" />
              <img src="@/assets/redesignImg/shophome.png" alt="" />
            </div>
            <div class="item">联系人：{{ messageData.contact }}</div>
            <div class="item">
              联系电话：
              <span v-if="showpNumber">
                {{ messageData.phoneNumber }}
              </span>
              <span v-else>
                {{ ShowPhone(messageData.phoneNumber) }}
              </span>

              <span
                class="showText"
                v-if="!showpNumber"
                @click="ShowPhoneNumber"
              >查看完整号码</span
              >
            </div>
            <div class="footer">
              <div class="textLeft" @click="enterpriseWeb">
                企业网站
              </div>
              <div class="box" @click="OnlineConsulting">
                <img src="@/assets/redesignImg/msg.png" alt="" />
                在线咨询
              </div>
            </div>
          </div>
          <div class="ImgContent">
            <img src="@/assets/redesignImg/adver.png" alt="" />
          </div>
          <div class="dataList">
            <div class="title">
              <div class="name">相关团队推荐</div>
              <div class="more" @click="More">查看更多</div>
            </div>
            <div class="itemList" v-if="newSettledListData.length > 0">
              <div
                class="item"
                v-for="(item, index) in newSettledListData"
                :key="index"
              >
                <div class="top">
                  <el-tooltip
                    popper-class="changeTootip"
                    effect="light"
                    :visible-arrow="false"
                    :content="item.teamName"
                    placement="bottom"
                    :offset="30"
                  >
                    <div
                      class="title"
                      style="color: #0286df !important;"
                      @click="GoDetila(item.no)"
                    >
                      {{ item.teamName }}
                    </div>
                  </el-tooltip>
                  <!-- <div class="address">
                    浏览数：{{ Math.floor(Math.random() * 1000 + 1)}}人
                  </div> -->
                </div>
                <div class="bottom">
                  <div class="type">
                    所在地区：
                    <span>
                      {{ item.provinceName ? item.provinceName : null
                      }}{{ item.cityName ? "/" + item.cityName : null }}</span
                    >
                  </div>
                  <!-- <div class="type">
                    人员规模：
                    <span> {{item.teamSize}}</span>
                  </div> -->
                  <div class="type">
                    <!-- 工队分类： -->
                    主营业务：
                    <span>
                      <el-tooltip
                        popper-class="changeTootip"
                        effect="light"
                        :visible-arrow="false"
                        :content="ChangeToString(item.businessScopes)"
                        placement="bottom"
                        :offset="30"
                      >
                        <div style="display: inline">
                          {{ ChangeToString(item.businessScopes) }}
                        </div>
                      </el-tooltip>
                    </span>
                  </div>
                  <!-- <div class="business">
                    主营业务：
                    <span>
                      <el-tooltip
                        popper-class="changeTootip"
                        effect="light"
                        :visible-arrow='false'
                        :content="ChangeToString(item.businessScopes,'left')"
                        placement="bottom"
                        :offset='30'
                      >
                        <div style="display: inline"> {{ChangeToString(item.businessScopes,'left')}} </div>
                      </el-tooltip>

                    </span>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="noList" v-else>
              <!-- 暂无数据 -->
            </div>
            <!-- <div class="more">
              查看更多>>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiTalentsMess } from "@/api/apiTalentsMess"
import link from "@/public/link.js"
import { formatDate2 } from "@/filters"
import sessionStorage from "@/storage/sessionStorage"
// import LeaseList from "@/views/RedesignTeamList/component/LeaseList" // 出租列表（文字格式）
// import Pagination from "@/views/Construction/components/Pagination" // 分页
import { apiResignAll } from "@/api/apiResignAll"
import localStorage from "@/storage/localStorage"
export default {
  name: "ConstructionDetails",
  props: {},
  data() {
    return {
      ShowMoreText: true,
      isHtml: false,
      equipmentDetails: {},

      teamSizeOption: [],

      showpNumber: false,
      // 当前标志
      InfoNo: null,
      // 主题信息
      UserInfo: {},
      // 详情信息
      messageData: {
        besinessScope: "",
        contact: "",
        id: 3,
        no: "",
        phoneNumber: "",
        serviceArea: "",
        teamIntroduce: "",
        teamName: "",
        teamSize: 0,
        teamStatus: null,
        companyId: null
      },

      checkIndex: 0,
      phone: "",
      title: {
        name: "",
        updateTime: null
      },
      breadcrumbObj: {
        title: "当前位置：",
        fristName: "首页",
        fristPath: "/",
        secondName: "工队列表",
        secondPath: "/teamList",
        threeName: "设备详情"
      },
      Sectab: [
        {
          name: "施工报价",
          show: true
        },
        {
          name: "团队简介",
          show: true
        },

        {
          name: "自有设备",
          show: true
        }
      ],
      tab: [
        {
          name: "施工报价",
          show: true
        },
        {
          name: "团队简介",
          show: true
        },
        {
          name: "团队业绩",
          show: true
        },

        // {
        //   name: "资质证书",
        //   show: true
        // },
        {
          name: "人员组成",
          show: true
        },
        {
          name: "自有设备",
          show: true
        },
        {
          name: "视频相册",
          show: true
        }
      ],
      IsPerson: true,
      constructionTeamData: {},
      teamTypeData: [],
      teamSkillsData: [],
      rollScroll: false,
      // 视频相册
      CertList: [],
      VideoParam: {
        page: 1,
        limit: 20
      },

      // 施工报价
      offerdataList: [],
      offerTitleList: [
        "工程分类",
        "计量单位",
        "包含设备",
        "包含辅材",
        "单位报价(元)",
        "报价原则"
      ],
      offerloadingTrue: false,
      offernoTextData: false,
      offerParam: {
        page: 1,
        limit: 20,
        basicInfoNo: null
      },
      // 团队业绩
      dataList: [],
      performanceTitleList: [
        "项目名称",
        "工程地点",
        "承包单位",
        "开工/竣工",
        "项目描述",
        "施工内容",
        "证明材料"
      ],
      loadingTrue: false,
      noTextData: false,
      performanceParam: {
        page: 1,
        limit: 20,
        basicInfoNo: null
      },
      // 人员组成
      teamPersondataList: [],
      personTitleList: ["姓名", "年龄", "工龄", "职位", "简介", "专业证书"],
      loadingTruePerson: false,
      noTextDataPerson: false,
      performanceParamPerson: {
        page: 1,
        limit: 20,
        basicInfoNo: null
      },
      // 自由设备
      equTeamList: [],
      equTitleList: [
        "设备名称",
        "设备描述",
        "规格型号",
        "设备图片",
        "证明材料"
      ],
      equloadingTrue: false,
      equnoTextData: false,
      equParam: {
        page: 1,
        limit: 20,
        basicInfoNo: null
      },


      CertloadingTrue: false,
      CertnoTextData: false,
      CertParam: {
        page: 1,
        limit: 20
      },
      newSettledListData: []
    }
  },
  computed: {},
  components: {
    // LeaseList,
    // Pagination,
    // Title: () => import('@/components/details/Title'),
    Breadcrumb: () => import("@/components/public/RedesignBreadcrumb"),
    // Tab: () => import("@/views/Construction/components/Tab"),
    // DetailsInner1: () =>
    //   import("@/views/Construction/components/DetailsInner1"),
    // DetailsInner2: () =>
    //   import("@/views/Construction/components/DetailsInner2"),
    // DetailsInner3: () =>
    //   import("@/views/Construction/components/DetailsInner3"),
    // DetailsInner4: () => import("@/views/Construction/components/DetailsInner4")
  },

  created() {
    const DetailsIndexKey = localStorage.read("DetailsIndexKey")
    if (DetailsIndexKey === 1) {
      //
      this.breadcrumbObj = {
        title: "当前位置：",
        fristName: "首页",
        fristPath: "/",
        secondName: "工队列表",
        secondPath: "/teamList",
        threeName: "工队详情 / 设备详情"
      }
    } else if (DetailsIndexKey === 2) {
      this.breadcrumbObj = {
        title: "当前位置：",
        fristName: "首页",
        fristPath: "/",
        secondName: "需求大厅",
        secondPath: "/demandHall",
        threeName: "工程详情 / 设备详情"
      }
    } else if (DetailsIndexKey === 3) {
      this.breadcrumbObj = {
        title: "当前位置：",
        fristName: "首页",
        fristPath: "/",
        secondName: "工队报价",
        secondPath: "/volunteerTeamOffer",
        threeName: "工队详情 / 设备详情"
      }
    }
    this.equipmentDetails = sessionStorage.read("equipmentDetails")
      ? JSON.parse(sessionStorage.read("equipmentDetails"))
      : {}
    //
    const id = sessionStorage.read("equNo")
    if (id) {
      this.TeamInfoDetail(id)
    }
    this.getteamSizeOption()
  },
  methods: {
    // 返回
    goBack() {
      this.$router.go(-1)
    },
    // 企业网站
    enterpriseWeb() {
      window.open(
        process.env.VUE_APP_MATERIALSURL +
          "/#/company/" +
          this.messageData.companyId,
        "_blank"
      )
    },
    GoDetila(id) {
      this.$router.push({ path: `/teamDetails/${id}` })
      location.reload()
    },
    // 获取视频相册
    async GetfindAlbumByTeamNo(data) {
      let res = await apiResignAll.GetfindAlbumByTeamNo(data)
      //
      //
      //
      this.CertList = res.data.data
      // this.loadingTrue = false;
    },
    // 地址
    ChangeAddress(data) {
      var array = []
      if (data) {
        const objArray = JSON.parse(data) ? JSON.parse(data) : []
        //

        objArray.map(item => {
          array.push(item.name)
        })
      }
      //
      const string = array.join(",")
      return string
    },
    // 报价分页
    offergetPage() {
      this.getTeamOffer(this.offerParam)
    },
    // 设备分页
    equgetTeam() {
      this.teamDetailEquipmentList(this.equParam)
    },
    // typeString
    ChangeString(data) {
      const stringF = data.firstCategoryName ? data.firstCategoryName : ""
      const stringS = data.secondCategoryName
        ? `/${data.secondCategoryName}`
        : ""
      const stringT = data.thirdCategoryName ? `/${data.thirdCategoryName}` : ""
      return `${stringF} ${stringS}${stringT} `
    },
    // 业绩分页
    getTeamperformance() {
      this.getTeamResults(this.performanceParam)
    },
    // 人员分页
    getTeamPersonPage() {
      this.getTeamPerson(this.performanceParamPerson)
    },
    // 获得推荐列表
    async newSettledList(id, no) {
      const obj = {
        id,
        no
      }
      let res = await apiResignAll.recommendList(obj)

      if (res && res.data && res.data.code === 200) {
        this.newSettledListData = res.data.data.slice(0, 3)
      }
    },
    // 查看更多
    More() {
      this.$store.commit("SET_INDEXKEY", 1)
      localStorage.set("indexKey", 1)
      this.$router.push("/teamList")
    },
    // 联系号码
    ShowPhone(phone) {
      if (phone && phone.length === 11) {
        const number = `${phone.slice(0, 3)}****${phone.slice(7, 11)}`
        return number
      }
    },

    // 获得团队规模
    async getteamSizeOption() {
      let res = await apiResignAll.getteamSizeOption()
      //
      //
      if (res && res.data && res.data.code === 200) {
        this.teamSizeOption = res.data.data
      }
    },
    // 团队规模
    SizeData(data) {
      const obj = this.teamSizeOption.find(
        (value, index, array) => value.no === data
      )
      if (obj) {
        return obj.name
      }
      // switch (Number(data)) {
      //   case 0:
      //     return "-";
      //   case 1:
      //     return "10-30人";
      //     break;
      //   case 2:
      //     return "30-50人";
      //     break;
      //   case 3:
      //     return "50-80人";
      //     break;
      //   case 4:
      //     return "80-100人";
      //     break;
      //   case 5:
      //     return "100人以上";
      //     break;
      //   default:
      //     break;
      // }
    },
    // 主营业务
    ChangeToString(data) {
      if (data) {
        // const array = JSON.parse(data);
        const array = data
        const arrayIndex = []
        array.map(item => {
          const stringData = `${
            item.firstCategoryName ? item.firstCategoryName : ""
          }${item.secondCategoryName ? "/" + item.secondCategoryName : ""}
          ${item.thirdCategoryName ? "/" + item.thirdCategoryName : ""}`
          arrayIndex.push(stringData)
        })
        return arrayIndex.join(" ; ")
      } else {
        return null
      }
    },
    // ChangeToString(data, index) {
    //   if (data) {
    //     if (index == "left") {
    //       const array = data;

    //       const arrayIndex = [];
    //       array.map(item => {
    //         const stringData =
    //           `${item.firstCategoryName}` + "/" + `${item.secondCategoryName}`;
    //         arrayIndex.push(stringData);
    //       });
    //       return arrayIndex.join(",");
    //     } else {
    //       const array = JSON.parse(data);
    //       const arrayIndex = [];
    //       array.map(item => {
    //         const stringData =
    //           `${item.firstCategoryName}` + "/" + `${item.secondCategoryName}`;
    //         arrayIndex.push(stringData);
    //       });
    //       return arrayIndex.join(",");
    //     }
    //   } else {
    //     return null;
    //   }
    // },
    // 获得详情
    async TeamInfoDetail(id) {
      let res = await apiResignAll.TeamInfoDetail(id)
      //
      //
      if (res && res.data && res.data.code === 200) {
        Object.assign(this.messageData, res.data.data)
        // this.messageData.isCompany = 2;

        // 请求业绩

        this.performanceParam.basicInfoNo = this.messageData.no
        this.getTeamResults(this.performanceParam)

        // 获得人员
        this.performanceParamPerson.basicInfoNo = this.messageData.no
        this.getTeamPerson(this.performanceParamPerson)

        // 获得设备信息
        this.equParam.basicInfoNo = this.messageData.no
        this.teamDetailEquipmentList(this.equParam)

        // 获得施工报价
        this.offerParam.basicInfoNo = this.messageData.no
        this.getTeamOffer(this.offerParam)

        // 团队推荐
        this.newSettledList(this.messageData.provinceNo, id)

        // 获取视频相册
        this.GetfindAlbumByTeamNo(id)

        // if (
        //   this.messageData.equipments &&
        //   this.messageData.equipments.length > 0
        // ) {
        //   this.equTeamList = this.messageData.equipments;
        // } else {
        //   this.equnoTextData = true;
        // }

        // 获得证书
        // this.getCertList();
      }
    },

    // 获得施工报价
    async getTeamOffer(data) {
      let res = await apiResignAll.getTeamteamPrice(data)
      if (res && res.data && res.data.code === 200) {
        this.offerdataList = res.data.data.records
        if (this.offerdataList.length === 0) {
          this.offernoTextData = true
        } else {
          this.offernoTextData = false
        }
        this.$set(this.offerParam, "total", res.data.data.total)
      }
    },
    // 获得业绩
    async getTeamResults(data) {
      let res = await apiResignAll.getTeamResults(data)
      if (res && res.data && res.data.code === 200) {
        this.dataList = res.data.data.records
        if (this.dataList.length === 0) {
          this.noTextData = true
        } else {
          this.noTextData = false
        }
        this.$set(this.performanceParam, "total", res.data.data.total)
      }
    },

    // 获得人员
    async getTeamPerson(data) {
      let res = await apiResignAll.getTeamPerson(data)
      if (res && res.data && res.data.code === 200) {
        this.teamPersondataList = res.data.data.records
        if (this.teamPersondataList.length === 0) {
          this.noTextDataPerson = true
        } else {
          this.noTextDataPerson = false
        }
        this.$set(this.performanceParamPerson, "total", res.data.data.total)
      }
    },

    // 获取设备
    async teamDetailEquipmentList(data) {
      let res = await apiResignAll.getequipmentList(data)

      if (res && res.data && res.data.code === 200) {
        this.equTeamList = res.data.data.records
        if (this.equTeamList.length === 0) {
          this.equnoTextData = true
        } else {
          this.equnoTextData = false
        }
        this.$set(this.equParam, "total", res.data.data.total)
      }
    },

    // 获取证书
    async getCertList() {
      let res = await apiResignAll.getCertificateList()
      if (res && res.data && res.data.code === 200) {
        this.CertList = res.data.data.records
        if (this.CertList.length === 0) {
          this.CertnoTextData = true
        } else {
          this.CertnoTextData = false
        }
      }
    },

    // 在线咨询
    OnlineConsulting() {
      if (this.$store.state.loginType) {
        //   添加IM
      } else {
        this.loginIndex()
      }
    },
    //  查看联系方式
    ShowPhoneNumber() {
      if (this.$store.state.loginType) {
        this.showpNumber = true
      } else {
        this.loginIndex()
      }
    },
    loginIndex() {
      let data = {
        callBack: function() {
          this.$store.dispatch("setUser")
          this.pushThis()
        }.bind(this)
      }
      this.$_login(data)
    },

    formatDate2,
    computedP() {
      let infobox = document.getElementsByClassName("p_content")
      Array.from(infobox).forEach(element => {
        if (element.offsetHeight < 93) {
          element.nextSibling.style.display = "none"
        } else {
          element.style.height = "96px"
        }
      })
    },
    hasClass(_classList, _className) {
      if (_classList.indexOf(_className) !== -1) {
        return true
      } else {
        return false
      }
    },
    targetOpen(e) {
      const currentTarget = e.currentTarget
      const child = currentTarget.parentNode.children
      const parent = currentTarget.parentNode
      const previous = currentTarget.parentNode.previousSibling
      if (this.hasClass(previous.className, "ellipsis4")) {
        previous.classList.remove("ellipsis4")
        previous.style.height = "auto"
        child[0].innerHTML = "点击收起"
        child[1].classList.remove("el-icon-caret-bottom")
        child[1].classList.add("el-icon-caret-top")
        parent.classList.add("isopen")
      } else {
        previous.classList.add("ellipsis4")
        previous.style.height = "96px"
        child[0].innerHTML = "点击展开"
        child[1].classList.remove("el-icon-caret-top")
        child[1].classList.add("el-icon-caret-bottom")
        parent.classList.remove("isopen")
      }
    },
    tel(telNum) {
      if (telNum) {
        let ary = telNum.split("")
        ary.splice(3, 4, "****")
        return ary.join("")
      }
      return ""
    },
    checkContactway() {
      if (this.$store.state.loginType) {
        this.constructionTeamData.concatPhone = this.phone
      } else {
        link.login()
        //   this.$confirm('当前未登录, 是否跳转到登录页面?', '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //   }).then(() => {
        //     window.location.href = process.env.VUE_APP_DOMAIN +'/login'
        //   })
      }
    },
    async iniData(id) {
      let getData = await apiTalentsMess.getTeamDetail(id)
      this.constructionTeamData = getData.data.data
      this.title.name = this.constructionTeamData.title
      this.title.updateTime = this.constructionTeamData.submitTime
      let typeData = await apiTalentsMess.getTeamType(id)
      this.teamTypeData = typeData.data.data.first
      this.teamSkillsData = typeData.data.data.second
      this.getShowTab()
      // this.$refs.tab.listener();

      this.phone = this.constructionTeamData.concatPhone
      this.constructionTeamData.concatPhone = this.tel(
        this.constructionTeamData.concatPhone
      )
    },
    check(index) {
      this.checkIndex = index
      // switch (index) {
      //   case 0:
      //     this.$refs.detailsInner1.toOffset()
      //     break
      //   case 1:
      //     this.$refs.detailsInner2.toOffset()
      //     break
      //   case 2:
      //     this.$refs.detailsInner3.toOffset()
      //     break
      //   case 3:
      //     this.$refs.detailsInner4.toOffset()
      //     break
      // }
    },
    changeRollScroll(bol) {
      this.rollScroll = bol
    },

    menu() {
      // let dom = document.documentElement.scrollTop + document.body.scrollTop;
      // let height1, height2, height3, height4;
      // if (this.tab[0].show) {
      //   height1 = this.$refs.detailsInner1.getHeight();
      // }
      // if (this.tab[1].show) {
      //   height2 = this.$refs.detailsInner2.getHeight();
      // }
      // if (this.tab[2].show) {
      //   height3 = this.$refs.detailsInner3.getHeight();
      // }
      // if (this.tab[3].show) {
      //   height4 = this.$refs.detailsInner4.getHeight();
      // }
      // if (dom >= height4 && height4) {
      //   this.$refs.tab.checkIndex = 3;
      // } else if (dom >= height3 && height3) {
      //   this.$refs.tab.checkIndex = 2;
      // } else if (dom >= height2 && height2) {
      //   this.$refs.tab.checkIndex = 1;
      // } else if (dom >= height1 && height1) {
      //   this.$refs.tab.checkIndex = 0;
      // }
    },
    getShowTab() {
      // if (this.constructionTeamData.performances.length === 0) {
      //   this.$set(this.tab[1], 'show', false)
      // }
      // if (this.constructionTeamData.talents.length === 0) {
      //   this.$set(this.tab[2], 'show', false)
      // }
      // if (!this.constructionTeamData.equipment) {
      //   this.$set(this.tab[3], 'show', false)
      // }
    }
  },
  watch: {
    CertList(n, o) {
      if (n && n.length > 0) {
        n.map(idx => {
          if (idx.type === 1) {
            // 图片
            const array = []
            array.push(idx.url)
            idx.picturePicData = array
          } else if (idx.type === 2) {
            // 视频
            idx.pictureVideoData = idx.url
          }
        })
        //
      }
    },
    equTeamList(n, o) {
      //
      n.map(item => {
        //
        if (typeof item.picture === "string") {
          item.picture = item.picture.split(",")
        }
      })
    },
    "messageData.teamIntroduce": {
      handler() {
        this.$nextTick(function() {
          //
          let sort = window.getComputedStyle(this.$refs.textShow).height
          let height = sort.slice(0, -2)
          //
          if (Number(height) >= 115) {
            this.isHtml = true
          } else {
            this.isHtml = false
          }
        })
      },
      deep: true
    },
    checkIndex: {
      handler(newValue) {
        //
        if (newValue === 1) {
          this.$nextTick(function() {
            //
            let sort = window.getComputedStyle(this.$refs.textShow).height
            let height = sort.slice(0, -2)
            //
            if (Number(height) >= 115) {
              this.isHtml = true
            } else {
              this.isHtml = false
            }
          })
        }
      },
      deep: true
    }
  },
  async mounted() {
    // await this.iniData(this.$route.params.id);
    // window.addEventListener("scroll", this.menu);
  },
  destroyed() {
    // window.removeEventListener("scroll", this.menu);
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "~@/styles/variable.scss";
.bgdf {
  background: #dfe4ea;
}
.talents {
  width: 100%;
  background: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  &_details {
    width: 1200px;
    background: #f5f5f5;
    &_content {
      width: 1200px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      &_left {
        .titleTop {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: white;

          padding: 20px 20px;
          border-bottom: 1px solid #f1f1f1;
          .left {
            padding: 0 10px;
            border-left: 3px solid #0286df;
          }
          .right {
            color: #0099ff;
            margin-left: 14px;
            text-decoration: underline;
            cursor: pointer;
          }
        }
        .equInfoDeatils {
          width: 100%;
          width: 880px;
          background: white;
          &_Content {
            width: 100%;
            .title {
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(0, 0, 0, 1);
              line-height: 20px;
              padding: 20px;
            }
            .titleText {
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: rgba(0, 0, 0, 1);
              line-height: 20px;
              padding: 0 20px;
              padding: 20px;
            }
            .titleType {
              margin-top: 20px;
              padding: 0 20px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              line-height: 20px;
            }
            .titleBorder {
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(2, 134, 223, 1);
              line-height: 24px;
              color: #0286df;
              padding: 20px;
              > div {
                border-left: 3px solid #0286df;
                padding-left: 10px;
                // padding-bottom: 10px;
                // border-bottom: 1px solid rgba(228, 231, 237, 1);
              }
            }
            .des {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              line-height: 23px;
              padding: 0 20px;
              > div {
                padding: 20px 0;
                border-top: 1px solid rgba(228, 231, 237, 1);
              }
              .text {
                margin-bottom: 30px;
                display: -webkit-box;
                overflow: hidden;
                -webkit-line-clamp: 5;
                -webkit-box-orient: vertical;
              }

              .actionShow {
                display: -webkit-box;
                overflow: hidden;
                -webkit-line-clamp: 100;
                -webkit-box-orient: vertical;
              }
              .optionShow {
                //  margin-bottom: 30px;
                .showUp {
                  color: #0286df;
                  cursor: pointer;
                }
                .showDown {
                  color: #ff6600;
                  cursor: pointer;
                }
              }
            }
            .imgBox {
              padding: 0 20px;
              > div {
                padding: 20px 0;
                border-top: 1px solid rgba(228, 231, 237, 1);
                img {
                  width: 216px;
                  height: 140px;
                  display: inline-block;
                  margin: 0 20px 20px 0;
                }
              }
            }
            &_form {
              padding: 10px 20px 0;
              .upLoadBox {
                width: 148px;
                height: 148px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                span {
                  display: inline-block;
                  line-height: 24px;
                }
              }
              .showImgBox {
                width: 486px;
                display: inline-block;
                border: 1px solid red;
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;
                position: relative;
                margin-top: 10px;
                // top: -151px;
                // z-index: 1;
                .icon {
                  display: inline-block;
                  width: 142px;
                  height: 142px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin: 0 20px 20px 0;
                }
                .showImg {
                  display: inline-block;
                  width: 140px;
                  height: 140px;
                  border: 1px solid blue;
                  margin: 0 20px 20px 0;
                }
              }

              .el-form--inline .el-form-item .serveAddress {
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                flex-wrap: wrap;
                .el-tag {
                  height: 40px;
                  color: #666;
                  margin: 0 5px 5px 5px;
                  padding: 6px;
                  min-width: 75px;
                  font-size: 14px;
                  line-height: 26px;
                  user-select: none;
                  text-align: center;
                  background-color: #fff;
                  font-family: PingFangSC-Regular;
                  .el-icon-close {
                    border-radius: 50%;
                    text-align: center;
                    position: relative;
                    cursor: pointer;
                    font-size: 12px;
                    height: 16px;
                    width: 16px;
                    line-height: 16px;
                    vertical-align: middle;
                    top: -1px;
                    right: 2px;
                  }
                }
              }
            }
            &_table {
              padding: 0 20px;
              min-height: 300px;
            }
          }
        }
      }
      &_right {
        width: 300px;
        margin-left: 20px;
        .PersonMessage {
          padding: 10px 20px;
          background: white;
          box-shadow: 0 2px 5px #e1e1e1;
          border-bottom: 1px solid #e4e7ed;
          margin-bottom: 10px;
          .name {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
            line-height: 36px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .describe {
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 200px;
            }
            .text {
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 200px;
            }
            .icon {
              display: inline-block;
              background: rgba(2, 134, 223, 1);
              border-radius: 4px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 21px;
              margin-left: 20px;
              padding: 0px 6px;
            }
          }
          .imgIcon {
            img {
              display: inline-block;
              // width: 10px;
              // height: 10px;
              // border: 1px solid #999;
              margin-right: 15px;
            }
          }
          .item {
            font-size: 14px;
            line-height: 30px;
            span.showText {
              color: #0099ff;
              margin-left: 14px;
              text-decoration: underline;
              cursor: pointer;
            }
          }
          .box {
            // margin: 10px 0 20px;
            border: 1px solid #0099ff;
            color: #0099ff;
            width: 80px;
            font-size: 14px;
            // text-align: center;
            padding: 8px 15px;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 15px auto;
            img {
              margin-right: 5px;
            }
            cursor: pointer;
          }
        }
        .EnterpriseMessage {
          padding: 10px 20px;
          background: white;
          box-shadow: 0 2px 5px #e1e1e1;
          border-bottom: 1px solid #e4e7ed;
          margin-bottom: 10px;
          .name {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
            line-height: 36px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .describe {
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 200px;
            }
            .text {
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 200px;
            }
            .icon {
              display: inline-block;
              background: rgba(2, 134, 223, 1);
              border-radius: 4px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 21px;
              margin-left: 20px;
              padding: 0px 6px;
            }
          }
          .imgIcon {
            img {
              display: inline-block;
              // width: 10px;
              // height: 10px;
              // border: 1px solid #999;
              margin-right: 15px;
            }
          }
          .item {
            font-size: 12px;
            line-height: 30px;
            span.showText {
              color: #0099ff;
              margin-left: 14px;
              text-decoration: underline;
              cursor: pointer;
            }
          }
          .footer {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .textLeft {
              cursor: pointer;
              background: #0099ff;
              color: white;
              width: 80px;
              font-size: 14px;
              // text-align: center;
              padding: 5px 5px;
              border-radius: 5px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin: 15px auto;
              margin: 15px 10px 15px auto;
            }
            .box {
              // margin: 10px 0 20px;
              border: 1px solid #0099ff;
              color: #0099ff;
              width: 80px;
              font-size: 14px;
              // text-align: center;
              padding: 5px 5px;
              border-radius: 5px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin: 15px auto;
              margin: 15px 15px auto 10px;
              img {
                margin-right: 5px;
              }
              cursor: pointer;
            }
          }
        }
        .ImgContent {
          width: 300px;
          height: 100px;
          // margin: 10px 0;
          margin-bottom: 10px;
          border: 1px solid #ccc;
        }
        .dataList {
          width: 260px;
          padding: 20px;
          background: white;
          margin-bottom: 30px;
          > .title {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .name {
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(2, 134, 223, 1);
              line-height: 30px;
              border-left: 3px solid #0286df;
              padding-left: 10px;
            }
            .more {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              line-height: 36px;
              cursor: pointer;
            }
          }
          .itemList {
            padding: 10px 0px;
            .item {
              border: 1px solid rgba(228, 230, 237, 1);
              font-size: 12px;
              color: #999;
              line-height: 30px;
              margin-bottom: 20px;
              .top {
                padding: 10px 8px;
                // height: 90px;
                max-height: 90px;
                background: rgba(245, 247, 250, 1);
                .title {
                  color: #000;
                  font-size: 14px;
                  font-weight: 300;
                  cursor: pointer;

                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }
              }
              .bottom {
                padding: 10px 8px 0 8px;
                height: 90px;
                height: 70px;
                .type {
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                .business {
                  line-height: 30px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
              span {
                color: #333;
              }
            }
          }
          .noList {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 275px;
          }
          // .more {
          //   font-size: 12px;
          //   color: #999;
          //   text-align: right;
          //   margin: 10px 20px 30px;
          //   cursor: pointer;
          // }
        }
      }
    }
  }
}

.noData {
  width: 100%;
  margin-bottom: 50px;
  background: #ffffff;
  padding-bottom: 40px;
  padding-top: 50px;
  border-radius: 0 0 4px 4px;
  border-top: none;
  box-sizing: border-box;
  .noDataImg {
    width: 177px;
    margin: 0 auto 15px;
    img {
      width: 100%;
    }
  }
  .noText {
    text-align: center;
    font-size: 18px;
    color: #333;
  }
}
</style>
<style lang="scss" rel="stylesheet/scss">
.changeTootip {
  border: 1px solid #767676 !important;
  padding: 4px !important;
  font-size: 12px !important;
  font-family: Microsoft YaHei;
  // font-weight: 300 !important;
  color: rgba(102, 102, 102, 1) !important;
  border-radius: 2px !important;
  max-width: 1200px !important;
}
</style>
